import React from "react";
import { useState, useEffect } from "react";
import { DeleteOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";

import { Typography, Space, Slider, Rate } from "antd";

import { ConfigTypeSingle } from "@shared/lib/types";

import HelpPopOver from "../../../shared/ui/HelpPopover";
import { useGetInfluencerStore } from "../lib/store/useGetInfluencerStore";

const { Paragraph, Title } = Typography;

interface Props extends ConfigTypeSingle {
  isOnSearch?: boolean;
}
const CustomStar: React.FC<Props> = ({
  compType,
  desc,
  facetName,
  isSearchable,
  title,
  placeHolder,

  isOnSearch = false,
}) => {
  const [visible, setVisible] = useState<boolean>(isOnSearch);

  const { selectedFilters, updateFilters } = useGetInfluencerStore();

  const selectedValue = Number(selectedFilters[facetName] || 0);

  return (
    <div>
      {!isOnSearch && (
        <Space
          onClick={() => setVisible(!visible)}
          size={"small"}
          align="center"
          style={{
            marginBottom: "5px",
            color: visible ? "#1677ff" : undefined,
          }}
        >
          {visible ? <PlusOutlined size={19} /> : <MinusOutlined size={19} />}
          <Title
            level={5}
            style={{ marginBlock: 0, color: visible ? "#1677ff" : undefined }}
          >
            {title}
          </Title>
          {desc && <HelpPopOver customText={desc} color="black" />}
        </Space>
      )}
      {visible && (
        <div>
          <Rate
            defaultValue={0}
            onChange={(val) => {
              updateFilters(facetName, val);
            }}
            value={selectedValue}
          />
        </div>
      )}
    </div>
  );
};

export default CustomStar;
